export const predictive_connect = {
  name: 'predictive_connect',
  title: 'autocaller_v2.breadcrumb.title',
  icon: () => import('@shared/components/icon/sidebar/icon-predictive.vue'),
  route: { name: 'predictive_connect.index' }
};
